
import { defineComponent } from "vue";
import BonoHeroLettering from "./bonoHero/BonoHeroLettering.vue";

export default defineComponent({
  components: {
    BonoHeroLettering,
  },
  setup() {
    return {
      baseURL: process.env.BASE_URL,
    };
  },
});
